<template>
  <div>
    <div class="field">
      <div class="field is-horizontal">
        <div class="field-body">
          <div class="field-body">
            <div class="field has-addons">
              <div
                class="control has-icons-left has-icons-right"
                :class="{ 'is-loading': isSearching }">
                <input
                  class="input"
                  v-model="filter.query"
                  type="text"
                  placeholder="Start typing to filter"
                  @input="search">
                <span class="icon is-left">
                  <i class="mdi mdi-magnify mdi-18px" />
                </span>
              </div>
              <div class="control">
                <a
                  class="button is-primary is-outlined"
                  @click="reset()">
                  <span class="icon">
                    <i class="mdi mdi-close mdi-18px" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bulma-table
      class="table is-bordered is-striped is-narrow is-fullwidth"
      :columns="columns"
      :page-index="filter.pageIndex"
      :page-size="filter.pageSize"
      :total-rows="totalRows"
      :is-loading="isTableLoading"
      :sort-column="filter.sortColumn"
      :sort-order="filter.sortOrder"
      @pageChanged="onPageChange"
      @sort="sort">
      <tr
        v-for="(item,index) in availableItems"
        :key="item.itemId"
        @dblclick="onRowDoubleClick(index, $event)"
        :class="{ 'is-selected' : selectedRow === index }"
        @click="highlightSelected(index, $event)">
        <td>{{ item.itemNo }}</td>
        <td>{{ item.description }}</td>
        <td>
          <div class="has-text-right">{{ $filters.formatNumber(item.price, $userInfo.locale) }}</div>
        </td>
        <td>
          <div class="has-text-centered">
            <a
              class="button is-primary is-small is-inverted tooltip is-tooltip-topright"
              @click="addNewItem(index, $event)"
              data-tooltip="Click or double-click row to add item">
              <span class="icon is-medium">
                <i class="mdi mdi-plus mdi-24px" />
              </span>
            </a>
          </div>
        </td>
      </tr>
      <!-- <tr v-for="(item,index) in miscItems"
        v-bind:key="item.itemId"
        v-on:dblclick="onRowDoubleClick(index, $event)"
        :class="{ 'is-selected' : selectedRow === index }"
        @click="highlightSelected(index, $event)">
        <td>{{item.itemNo}}</td>
        <td>{{item.itemDesc}}</td>
        <td>
          <div class="has-text-right">{{item.value.toFixed(2)}}</div>
        </td>
        <td>
          <div class="has-text-centered">
            <a class="button is-primary is-small is-inverted tooltip is-tooltip-topright"
              @click="addNewItem(index, $event)"
              data-tooltip="Click or double-click row to add item">
              <span class="icon is-medium">
                <i class="mdi mdi-plus mdi-24px"></i>
              </span>
            </a>
          </div>
        </td>
      </tr> -->
      <template slot="empty">
        <div class="content has-text-grey has-text-centered">
          <span icon="icon is-large">
            <i class="mdi mdi-36px mdi-emoticon-sad" />
          </span>
          <p>Nothing</p>
        </div>
      </template>
    </bulma-table>
  </div>
</template>

<script>
import Guid from '@/components/Guid'
import _debounce from 'lodash.debounce'
import BulmaTable from '@/components/BulmaTable'
import { MiscItemColumns } from '../columns'
import InsurerService from '../InsurerService'

export default {
  name: 'AvailableMiscs',
  components: {
    BulmaTable
  },
  props: {
    itemType: {
      type: String,
      default: ''
    },
    value: Array,
    insurerId: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      miscItems: null,
      availableItems: null,
      pageIndex: 1,
      totalRows: 0,
      selectedRow: null,
      isSearching: false,
      isTableLoading: false,
      filter: {
        countryId: Guid.empty(),
        query: '',
        type: '',
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: 8
      }
    }
  },
  computed: {
    columns() {
      return MiscItemColumns
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  mounted() {
    this.getAvailableMiscs()
  },
  methods: {
    highlightSelected(index, event) {
      this.selectedRow = index
    },
    async getAvailableMiscs() {
      this.isSearching = true
      this.isTableLoading = true
      this.availableItems = await InsurerService.getAvailableMiscItemsProto(this.filter)
      this.totalRows = this.availableItems.length > 0 ? this.availableItems[0].totalRows : 0
      this.isSearching = false
      this.isTableLoading = false
    },
    addNewItem(index, event) {
      // Find item by item no
      const selectedItem = this.availableItems[index]
      const item = this.value.find(i => i.itemNo === selectedItem.itemNo && !i.isDeleted)
      if (!item) {
        const newItem = {
          autoItemId: Guid.newGuid(),
          insurerId: this.insurerId,
          isDeleted: false,
          isNew: true,
          itemDesc: selectedItem.description,
          itemNo: selectedItem.itemNo,
          itemType: 'AUTO',
          price: selectedItem.price,
          reportOnly: false
        }
        this.value.push(newItem)
      } else {
        this.$notification.openNotificationWithType('warning', 'Insurer', 'Item is already in selected list. Item not added.')
      }
    },
    reset() {
      this.filter.pageIndex = 1
      this.filter.query = ''
      this.filter.type = ''
      this.getAvailableMiscs()
    },
    sort(name, order) {
      this.filter.sortColumn = name
      this.filter.sortOrder = order
      this.getAvailableMiscs()
    },
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
      this.getAvailableMiscs()
    },
    onRowDoubleClick(index, event) {
      this.addNewItem(index, event)
    },
    search: _debounce(function() {
      this.filter.pageIndex = 1
      this.getAvailableMiscs()
    }, 500)
  }
}
</script>

<style lang="scss">
</style>
